export const START_STEP = 'START_STEP';
export const EMPTY_SNILS_STEP = 'EMPTY_SNILS_STEP';
export const STEP1 = 'STEP1';
export const STEP2 = 'STEP2';
export const STEP3 = 'STEP3';
export const STEP4 = 'STEP4';
